#@import GliveBooking.Models.Time
#@export GliveBooking.Collections.Times

class GliveBooking.Collections.Times extends BookingV2.Collections.Base
  model: GliveBooking.Models.Time
